import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { mapEstimatedDelivery } from '../mappers/estimated-delivery.js';
import { GET_ESTIMATED_DELIVERY_BY_SKUS } from '../operations/queries/get-estimated-delivery-by-skus.js';

const useGetEstimatedDeliveryMessage = (items, shippingMethodKey)=>{
    const { dateTime: { formatDate  } , getFormattedLabel , locale ,  } = useIntl();
    const { data , loading , error  } = useQuery(GET_ESTIMATED_DELIVERY_BY_SKUS, {
        variables: {
            input: {
                skuQuantityPairs: items,
                shippingMethodKey
            }
        }
    });
    const estimatedDelivery = mapEstimatedDelivery(data, locale);
    const deliveryMessage = (estimatedDelivery === null || estimatedDelivery === void 0 ? void 0 : estimatedDelivery.deliveryDate) ? getFormattedLabel('products.deliveryIndicator.deliveryIndicationFullDate', {
        labelData: {
            deliveryDate: formatDate(estimatedDelivery.deliveryDate, 'short'),
            deliveryMethod: estimatedDelivery.shippingMethodDescription
        }
    }) : '';
    if (error) {
        console.error(error);
    }
    return {
        deliveryMessage,
        loading,
        error
    };
};

export { useGetEstimatedDeliveryMessage };
//# sourceMappingURL=use-get-estimated-delivery-message.js.map
